import type { ResumeData } from '../types/resume';

export const resumeData: ResumeData = {
  name: 'Kevin Warnock',
  title: 'Senior Software Engineer',
  tagline: 'Full-Stack Engineer | Game Developer | Author & Creator',
  summary:
    'Seasoned Senior Software Engineer adept at leading cross-functional teams. Remarkable relationship building, decision making and communication skills. Known for best-in-class development and collaboration.',

  independentProjects: [
    {
      id: 'exp-1',
      company: 'AKGames',
      title: 'Game Developer',
      location: 'Remote',
      startDate: '04/2023',
      endDate: 'Present',
      highlights: [
        'Published Flippy Boi using Phaser 3 + Capacitor with a full release pipeline',
      ],
      technologies: ['Phaser 3', 'Capacitor', 'Unity', 'TypeScript', 'JavaScript', 'Android', 'iOS'],
    },
    {
      id: 'exp-2',
      company: 'AKWarnock',
      title: 'Author',
      location: 'Remote',
      startDate: '04/2023',
      endDate: 'Present',
      highlights: [
        'Co-authored The Spirit Blessed Chronicles',
      ],
      technologies: ['Creative Writing', 'Worldbuilding', 'Independent Publishing', 'Web Promotion'],
    },
    {
      id: 'exp-4',
      company: 'Independent Project Work',
      title: 'Podcast Host',
      location: 'Remote',
      startDate: '10/2024',
      endDate: '10/2025',
      highlights: [
        'Produced and distributed an independent podcast',
      ],
      technologies: ['Audio Production', 'Content Planning', 'Podcast Publishing', 'Media Distribution'],
    },
  ],

  experience: [
    {
      id: 'exp-3',
      company: 'Major Rocket',
      title: 'Senior Software Engineer',
      location: 'Remote',
      startDate: '07/2025',
      endDate: '03/2026',
      highlights: [
        'Architected AWS ECS/Fargate environments for scalable container orchestration',
        'Built multi-provider integration engine connecting disparate third-party services',
        'Developed admin tooling to streamline internal operations',
        'Improved async reliability across the platform',
      ],
      technologies: ['AWS', 'ECS', 'Fargate', 'Terraform', 'TypeScript', 'React'],
    },
    {
      id: 'exp-5',
      company: 'Authentic Digital Agency',
      title: 'Software Solutions Architect',
      location: 'Remote',
      startDate: '07/2021',
      endDate: '04/2024',
      highlights: [
        'Promoted from Senior Software Engineer to Software Solutions Architect, overseeing multiple client engagements',
        'Built a custom Bloomreach CMS implementation for the Audacy project, serving the largest radio content platform in the United States',
        'Worked on the digital presence for Audacy, the company that acquired iHeartRadio and the majority of U.S. radio content',
      ],
      technologies: ['Bloomreach CMS', 'React', 'Elasticsearch', 'API Integrations', 'Content Modeling', 'DXP'],
    },
    {
      id: 'exp-6',
      company: 'Kinsale Insurance',
      title: 'Senior Software Engineer',
      location: 'Richmond, VA',
      startDate: '10/2020',
      endDate: '06/2021',
      highlights: [
        'Led Angular development initiative as Subject Matter Expert and primary point-of-contact',
        'Trained and mentored junior developers in Angular, TypeScript, JavaScript, SCSS, HTML, Java, and PL/SQL',
        'Developed new vertically sliced features across the full stack',
        'Created proofs of concept for innovative new solutions',
        'Designed and developed forward-thinking systems that meet user needs and improve productivity',
        'Collaborated with cross-functional team members to analyze potential system solutions based on evolving client requirements',
        'Fixed all unit tests and acceptance tests within each code base contributed to',
      ],
      technologies: ['Angular', 'TypeScript', 'Java', 'PL/SQL', 'SCSS', 'HTML5'],
    },
    {
      id: 'exp-7',
      company: 'Apex Systems LLC',
      title: 'Senior Software Engineer',
      location: 'Richmond, VA',
      startDate: '08/2020',
      endDate: '10/2020',
      highlights: [
        'Worked on Dashboard and Job Scheduling functionality',
        'Decomposed large components into smaller, more manageable components',
        'Fixed all unit tests and acceptance tests within the code base',
        'Migrated application from Angular 9 to Angular 10',
        'Estimated work hours and tracked progress using Scrum methodology',
      ],
      technologies: ['Angular', 'TypeScript', 'JavaScript', 'Scrum'],
    },
    {
      id: 'exp-8',
      company: 'Capital One',
      title: 'Master Software Engineer',
      location: 'Richmond, VA',
      startDate: '12/2015',
      endDate: '04/2020',
      highlights: [
        'Delivered many production features and innovative solutions enabling migration from legacy systems while continuing feature delivery',
        'Developed internal tools: CI pipeline on Jenkins, GitHub web-hooks, custom cache busting, custom ts-lint rules',
        'Trained and mentored junior developers in OOP design patterns using NodeJS, Angular, TypeScript, Java and Groovy',
        'Migrated a large enterprise application from AngularJS v1.3 to Angular 8',
        'Extensive experience troubleshooting enterprise production systems',
        'Worked with project managers, developers, QA and customers to resolve technical issues',
      ],
      technologies: ['Angular', 'AngularJS', 'TypeScript', 'NodeJS', 'Java', 'Groovy', 'Jenkins'],
    },
    {
      id: 'exp-9',
      company: 'Celerity IT LLC',
      title: 'Senior Software Engineer',
      location: 'Richmond, VA',
      startDate: '12/2014',
      endDate: '12/2015',
      highlights: [
        'Contracted by Capital One to build new features, set application design patterns, and establish best practices',
        'Troubleshot production and pre-production enterprise application bugs and performance problems',
        'Developed processes and tools to enhance day-to-day development',
        'Set patterns and best practices for acceptance testing',
      ],
      technologies: ['Angular', 'TypeScript', 'JavaScript', 'HTML5', 'CSS3'],
    },
    {
      id: 'exp-10',
      company: 'Axseum Solutions LLC',
      title: 'Senior Software Engineer',
      location: 'Richmond, VA',
      startDate: '10/2014',
      endDate: '12/2014',
      highlights: [
        'Built new internal digital library for the Army Training Support Center (ATSC)',
        'Researched, tested, built, and integrated enhancements based on client requirements',
        'Developed processes, tools and best practices to enhance day-to-day development',
        'Designed, developed, and optimized web applications using HTML5, CSS3, and JavaScript',
      ],
      technologies: ['AngularJS', 'Java', 'HTML5', 'CSS3', 'JavaScript'],
    },
    {
      id: 'exp-11',
      company: 'Zantech IT Services Inc',
      title: 'Mobile/Web Application Developer',
      location: 'Richmond, VA',
      startDate: '05/2013',
      endDate: '09/2014',
      highlights: [
        'Built internal digital library for ATSC using AngularJS, HTML, CSS, and Java',
        'Designed, developed, and optimized web and hybrid applications (Cordova)',
        'Developed processes, tools and best practices to enhance development workflow',
      ],
      technologies: ['AngularJS', 'Java', 'Cordova', 'HTML5', 'CSS3', 'JavaScript'],
    },
    {
      id: 'exp-12',
      company: 'CRGT Inc',
      title: 'Business Systems Analyst',
      location: 'Richmond, VA',
      startDate: '02/2013',
      endDate: '05/2013',
      highlights: [
        'Maintained and enhanced internal ATSC applications through coding changes and database maintenance',
        'Released one of the largest improvements in over three years to AutoDB, an application used by Mission Support and the help desk',
      ],
      technologies: ['.NET 4.0', 'C#', 'SQL', 'Database Administration'],
    },
    {
      id: 'exp-13',
      company: 'CRGT Inc',
      title: 'Senior Help Desk Specialist',
      location: 'Richmond, VA',
      startDate: '05/2012',
      endDate: '02/2013',
      highlights: [
        'Identified, diagnosed and resolved software and hardware issues',
        'Built strong working relationships with customers to resolve technical issues efficiently',
        'Created batch files, PowerShell scripts and VBScript scripts to simplify day-to-day operations',
      ],
      technologies: ['PowerShell', 'VBScript', 'Batch Scripting', 'Windows'],
    },
  ],

  skills: [
    { id: 'skill-1', name: 'TypeScript', category: 'languages', level: 'expert' },
    { id: 'skill-2', name: 'JavaScript', category: 'languages', level: 'expert' },
    { id: 'skill-3', name: 'Java', category: 'languages', level: 'advanced' },
    { id: 'skill-4', name: 'C#', category: 'languages', level: 'proficient' },
    { id: 'skill-5', name: 'PHP', category: 'languages', level: 'proficient' },
    { id: 'skill-6', name: 'Python', category: 'languages', level: 'advanced' },
    { id: 'skill-7', name: 'Ruby', category: 'languages', level: 'proficient' },
    { id: 'skill-8', name: 'SQL', category: 'languages', level: 'advanced' },
    { id: 'skill-9', name: 'Angular', category: 'frontend', level: 'expert' },
    { id: 'skill-10', name: 'AngularJS', category: 'frontend', level: 'expert' },
    { id: 'skill-11', name: 'HTML5', category: 'frontend', level: 'expert' },
    { id: 'skill-12', name: 'HTML', category: 'frontend', level: 'expert' },
    { id: 'skill-13', name: 'SCSS', category: 'frontend', level: 'advanced' },
    { id: 'skill-14', name: 'React', category: 'frontend', level: 'advanced' },
    { id: 'skill-15', name: 'CSS', category: 'frontend', level: 'expert' },
    { id: 'skill-16', name: 'SASS', category: 'frontend', level: 'advanced' },
    { id: 'skill-17', name: 'NodeJS', category: 'backend', level: 'expert' },
    { id: 'skill-18', name: 'Ruby on Rails', category: 'backend', level: 'proficient' },
    { id: 'skill-19', name: 'PL/SQL', category: 'backend', level: 'advanced' },
    { id: 'skill-20', name: 'APIs', category: 'backend', level: 'advanced' },
    { id: 'skill-21', name: 'Full-stack development', category: 'backend', level: 'expert' },
    { id: 'skill-22', name: 'AWS', category: 'cloud', level: 'advanced' },
    { id: 'skill-23', name: 'AWS Lambda', category: 'cloud', level: 'advanced' },
    { id: 'skill-24', name: 'Terraform', category: 'cloud', level: 'advanced' },
    { id: 'skill-25', name: 'Docker', category: 'cloud', level: 'advanced' },
    { id: 'skill-26', name: 'Software Craftsmanship', category: 'practices', level: 'expert' },
    { id: 'skill-27', name: 'Debugging', category: 'practices', level: 'expert' },
    { id: 'skill-28', name: 'Mentoring', category: 'practices', level: 'expert' },
    { id: 'skill-29', name: 'Git', category: 'practices', level: 'expert' },
    { id: 'skill-30', name: 'XML', category: 'practices', level: 'proficient' },
  ],

  certifications: [
    { id: 'cert-1', name: 'CompTIA Security+ CE', abbreviation: 'Security+', issuer: 'CompTIA', year: 2019 },
    { id: 'cert-2', name: 'Microsoft Certified IT Professional', abbreviation: 'MCITP', issuer: 'Microsoft', year: 2012 },
    { id: 'cert-3', name: 'Microsoft Certified Solutions Associate', abbreviation: 'MCSA', issuer: 'Microsoft', year: 2012 },
    { id: 'cert-4', name: 'Microsoft Certified Technology Specialist', abbreviation: 'MCTS', issuer: 'Microsoft', year: 2012 },
    { id: 'cert-5', name: 'Microsoft Certified .NET 4.0 Web Applications Developer', abbreviation: '.NET 4.0', issuer: 'Microsoft', year: 2013 },
  ],

  education: [
    {
      id: 'edu-1',
      institution: 'Coastal College of Georgia',
      degree: 'Computer Science and Programming',
      field: 'Computer Science and Programming',
      year: 2010,
    },
    {
      id: 'edu-2',
      institution: 'Advanced Technology Institute',
      degree: 'Associate of Applied Science: Occupational Science',
      field: 'Occupational Science',
      year: 2005,
    },
  ],

  featuredWork: [
    {
      id: 'feat-1',
      title: 'Flippy Boi Mobile Game',
      description:
        'Designed and released an independent mobile game on the Android Play Store in the US and UK, handling game architecture, programming, deployment, and the full release pipeline.',
      impact: 'Successfully shipped a mobile game to market with store submission, updates, and advertising integration.',
      technologies: ['Phaser 3', 'Capacitor', 'TypeScript', 'Android'],
    },
    {
      id: 'feat-2',
      title: 'Integration Engine at Major Rocket',
      description:
        'Designed and implemented an integration engine responsible for synchronizing data across 8 external provider systems, with automated ingestion, normalization, and processing pipelines.',
      impact: 'Improved operational visibility and reduced manual intervention for integration workflows across the platform.',
      technologies: ['AWS', 'ECS', 'Fargate', 'Terraform', 'TypeScript'],
    },
    {
      id: 'feat-3',
      title: 'Bloomreach CMS Integration for Audacy',
      description:
        'Architected and implemented a Bloomreach CMS integration for Audacy that enabled dynamic content delivery powering their web and mobile application experiences, including a custom Elasticsearch query builder.',
      impact: 'Enabled flexible editorial workflows and high-volume digital publishing, leading to promotion to Business Systems Architect.',
      technologies: ['Bloomreach CMS', 'React', 'Elasticsearch', 'API Integrations'],
    },
    {
      id: 'feat-4',
      title: 'Enterprise AngularJS to Angular Migration',
      description:
        'Led the migration of a massive enterprise application from AngularJS v1.3 to Angular 8 at Capital One, while continuing to deliver business features during the transition.',
      impact: 'Enabled Capital One to move off a legacy framework to a modern, maintainable platform without disrupting feature delivery.',
      technologies: ['Angular', 'AngularJS', 'TypeScript', 'NodeJS'],
    },
    {
      id: 'feat-5',
      title: 'Custom Cache Busting & Developer Tooling',
      description:
        'Developed a suite of internal tools at Capital One including a custom cache busting solution, CI pipelines on Jenkins, GitHub web-hooks, and custom ts-lint rules to enforce code quality standards.',
      impact: 'Eliminated stale-cache deployment issues and enhanced day-to-day developer productivity and code quality across the platform.',
      technologies: ['Jenkins', 'GitHub', 'NodeJS', 'TypeScript'],
    },
    {
      id: 'feat-6',
      title: 'Angular SME Leadership at Kinsale Insurance',
      description:
        'Served as the Angular Subject Matter Expert and primary point-of-contact, leading the development initiative and mentoring junior developers across Angular, TypeScript, Java, and PL/SQL.',
      impact: 'Elevated the team\'s Angular capabilities, established best practices, and delivered vertically sliced full-stack features.',
      technologies: ['Angular', 'TypeScript', 'Java', 'PL/SQL'],
    },
    {
      id: 'feat-7',
      title: 'Dashboard & Angular Migration at Federal Reserve',
      description:
        'Built Dashboard and Job Scheduling functionality at the Federal Reserve Bank of Richmond, migrated the codebase from Angular 9 to Angular 10, and decomposed large components into maintainable units.',
      impact: 'Improved system performance and code maintainability while fixing all unit and acceptance tests across the codebase.',
      technologies: ['Angular', 'TypeScript', 'JavaScript'],
    },
    {
      id: 'feat-8',
      title: 'ATSC Digital Library',
      description:
        'Built an internal digital library for the Army Training Support Center (ATSC) using AngularJS, HTML, CSS, and Java, including hybrid mobile support via Cordova.',
      impact: 'Delivered a modern, accessible digital library replacing outdated systems for military training resources.',
      technologies: ['AngularJS', 'Java', 'Cordova', 'HTML5', 'CSS3'],
    },
    {
      id: 'feat-9',
      title: 'AutoDB Major Release at CRGT',
      description:
        'Released one of the largest improvements in over three years to AutoDB, an internal application used by Mission Support and the help desk at the Army Training Support Center.',
      impact: 'Modernized a critical internal tool that had been stagnant, directly improving daily operations for support staff.',
      technologies: ['.NET 4.0', 'C#', 'SQL'],
    },
  ],

  contact: [
    {
      id: 'contact-linkedin',
      type: 'linkedin',
      label: 'LinkedIn',
      url: 'https://www.linkedin.com/in/kevin-warnock-44b78484/',
    },
    {
      id: 'contact-github',
      type: 'github',
      label: 'GitHub',
      url: 'https://github.com/folterung',
    },
    {
      id: 'contact-email',
      type: 'email',
      label: 'Email',
      url: 'mailto:kevi.warnock@gmail.com',
    },
  ],
};
